import { render, staticRenderFns } from "./GenericControlsTable.vue?vue&type=template&id=7f905964&"
import script from "./GenericControlsTable.vue?vue&type=script&lang=js&"
export * from "./GenericControlsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports